module.exports = { id: "user", url: "/build/app/img/symbols.svg#user", viewBox: "", toString: function() { return this.url; } };